import { createEntityAdapter } from '@reduxjs/toolkit';
import { schema } from 'normalizr';
import { RootState } from 'redux/store';
import { GadgetModel } from 'types/entity';

export const gadgetSchema = new schema.Entity(
  'gadget',
  {},
  { idAttribute: (value: GadgetModel) => value.gadget_id || '' },
);

export const gadgetsAdaptor = createEntityAdapter<GadgetModel>({
  selectId: (model) => model.gadget_id || '',
});

export const {
  selectById: selectGadgetById,
  selectIds: selectGadgetIds,
  selectEntities: selectGadgetEntities,
  selectAll: selectAllGadgets,
  selectTotal: selectTotalGadgets,
} = gadgetsAdaptor.getSelectors<RootState>((state) => state.gadgetRead);
